import { render } from "./HeroiconsOutlineDatabase.vue?vue&type=template&id=11cba70d"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDatabase.vue"]])

export default __exports__